module.exports = __webpack_public_path__ + "static/media/bullseye.6487f695.svg";